import React, { useEffect, useState } from "react";
import vendor1Image from "../../assests/images/Vendor_1 (1).png";
import vendor2Image from "../../assests/images/Vendor2.png";
import vendor3Image from "../../assests/images/Vendor3.png";
import download1Image from "../../assests/images/download (1).png";
import jobwellImage from "../../assests/images/job-well.png";
import send1Image from "../../assests/images/send_1.png";

function EvaluationCommercial() {
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="listing_projectss">
            <p className="listing_rfq">
              Commercial Comparison
              <strong className="bidding_round_rfq">- Bidding Round 1</strong>
            </p>
            <div className="extend_evaluation">
              <button
                className="vendor_btn vendor_maine_content2"
                href="#"
                fdprocessedid="k4yyb6"
              >
                Close RFQ
              </button>
              <button
                className="vendor_btn vendor_maine_content2"
                href="#"
                fdprocessedid="k4yyb6"
              >
                Extend Validity
              </button>
              <button
                className="vendor_btn vendor_maine_content2"
                href="#"
                fdprocessedid="31fkt"
              >
                Extend Vendor
              </button>
              <button
                className="vendor_btn vendor_maine_content2"
              // onClick={() => {
              //   setOpenFinalizeEvaluation(true);
              // }}
              >
                Download Result
              </button>
            </div>
          </div>
          <div className="header_lineitem">
            <span className="line-tb">Header</span>
            <span className="header-tb">Line Items</span>
          </div>
          <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body ">
            <thead>
              <tr className="line_time_rfq_project_detail_body">
                <th className="boq_detail_technical_package_react">BOQ</th>
                <th className="boq_detail_technical_package_react">QTY</th>
                <th className="lets_oty_listing_detail_r_line">
                  <div className="vendor_b_react_package_blocklist_body">
                    <p className="vendor_a_react_body_list">Vendor A</p>
                    <img src={vendor1Image} alt="" />
                  </div>
                  <p class="bidding_block_sky">24-1-2024 | 12:45 AM</p>
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">Rate</p>
                    <p class="bidding_block_rate">Ammount</p>
                  </div>
                </th>
                <th class="lets_oty_listing_detail_r_line">
                  <div className="vendor_b_react_package_blocklist_body">
                    <p>
                      <b>Vendor B</b>
                    </p>
                    <img src={vendor2Image} alt="" />
                  </div>
                  <p class="bidding_block_sky">24-1-2024 | 12:45 AM</p>
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">Rate</p>
                    <p class="bidding_block_rate">Ammount</p>
                  </div>
                </th>
                <th class="lets_oty_listing_detail_r_line">
                  <div className="vendor_b_react_package_blocklist_body">
                    {" "}
                    <p>
                      <b>Vendor C</b>
                    </p>
                    <img src={vendor3Image} alt="" />
                  </div>
                  <p class="bidding_block_sky">24-1-2024 | 12:45 AM</p>
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">Rate</p>
                    <p class="bidding_block_rate">Ammount</p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="vendor_c_reacts_package_blocklist_body">
                  <p>
                    <b>Laptop</b>
                  </p>
                </td>
                <td>12</td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 500</p>
                    <p class="bidding_block_rate">₹ 500</p>
                  </div>
                </td>
                <td>
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 450</p>
                    <p class="bidding_block_rate">₹ 450</p>
                  </div>
                </td>
                <td>
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 300</p>
                    <p class="bidding_block_rate">₹ 300</p>
                  </div>
                </td>
              </tr>

              <tr>
                <td className="vendor_c_reacts_package_blocklist_body">
                  <p>
                    <b>Chairs</b>
                  </p>
                </td>
                <td>8</td>
                <td>
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 700</p>
                    <p class="bidding_block_rate">₹ 700</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <td>
                    {" "}
                    <div className="lets_table_vendor_detail_block_body_reacted">
                      <p class="bidding_block_rate">₹ 500</p>
                      <p class="bidding_block_rate">₹ 500</p>
                    </div>
                  </td>
                </td>
                <td>
                  {" "}
                  <td>
                    {" "}
                    <div className="lets_table_vendor_detail_block_body_reacted">
                      <p class="bidding_block_rate">₹ 450</p>
                      <p class="bidding_block_rate">₹ 450</p>
                    </div>
                  </td>
                </td>
              </tr>
              <tr>
                <td className="vendor_c_reacts_package_blocklist_body">
                  <p>
                    <b>Computer</b>
                  </p>
                </td>
                <td>4</td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 900</p>
                    <p class="bidding_block_rate">₹ 900</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 800</p>
                    <p class="bidding_block_rate">₹ 800</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 700</p>
                    <p class="bidding_block_rate">₹ 700</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="vendor_c_reacts_package_blocklist_body">
                  {/* <img src="images/blue-arrow.png" width="20px" height="20px"/> */}
                  <p>
                    <b>Hardisk Accessories</b>
                  </p>
                </td>
                <td>2</td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 1200</p>
                    <p class="bidding_block_rate">₹ 1200</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 1000</p>
                    <p class="bidding_block_rate">₹ 1000</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 1300</p>
                    <p class="bidding_block_rate">₹ 1300</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="vendor_c_reacts_package_blocklist_body">
                  {/* <img src="images/blue-arrow.png" width="20px" height="20px"> */}
                  <p>
                    <b>Laptop Charger</b>
                  </p>
                </td>
                <td>12</td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 400</p>
                    <p class="bidding_block_rate">₹ 400</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 600</p>
                    <p class="bidding_block_rate">₹ 600</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 900</p>
                    <p class="bidding_block_rate">₹ 900</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="vendor_c_reacts_package_blocklist_body">
                  {/* <img src="images/blue-arrow.png" width="20px" height="20px"> */}
                  <p>
                    <b>Tables</b>
                  </p>
                </td>
                <td>8</td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 2000</p>
                    <p class="bidding_block_rate">₹ 2000</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 2300</p>
                    <p class="bidding_block_rate">₹ 2300</p>
                  </div>
                </td>
                <td>
                  {" "}
                  <div className="lets_table_vendor_detail_block_body_reacted">
                    <p class="bidding_block_rate">₹ 1800</p>
                    <p class="bidding_block_rate">₹ 1800</p>
                  </div>
                </td>
              </tr>

              <tr>
                <td className="vendor_f_react_body_list_detail">
                  <h2>Total</h2>
                </td>
                <td className="vendor_f_react_body_list_detail">
                  <h2>22</h2>
                </td>
                <td className="vendor_f_react_body_list_detail">
                  <h2>5700</h2>
                </td>
                <td className="vendor_f_react_body_list_detail">
                  <h2>5650</h2>
                </td>
                <td className="vendor_f_react_body_list_detail">
                  <h2>5450</h2>
                </td>
              </tr>
              <tr className="custom-borders">
                <td className="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Tender Drawing</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Technical Specification</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p></p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p>
                    <div className="lets_profile_package_listing_react_body">
                      <p className="yes_technical_project_react_body1">
                        Approve
                      </p>
                    </div>
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p>
                    <div className="lets_profile_package_listing_react_body">
                      <p className="yes_technical_project_react_body1">
                        Approve
                      </p>
                    </div>
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p>
                    <div className="lets_profile_package_listing_react_body">
                      <p className="yes_technical_project_react_body1">
                        Approve
                      </p>
                    </div>
                  </p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Payment Terms</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Liquidated Damages</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">2%</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_f">5%</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">3%</p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Over all LD cap</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">Attached</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">Attached</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">Attached</p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Defect Liability Period</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">3 months</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">2 months</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">2.5 months</p>
                </td>
              </tr>

              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Service Contract Period</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">30 Days</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">45 Days</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">60 Days</p>
                </td>
              </tr>

              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Warrenty</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="yes_technical_project_react_body1">Yes</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="no_technical_project_react_body1">No</p>
                </td>
                <td class="border-top border-bottom">
                  <p className="yes_technical_project_react_body1">Yes</p>
                </td>
              </tr>
              <tr class="custom-borders">
                <td class="border-top border-bottom text-end">
                  <p className="tender_drawing_f">
                    <b>Capacity</b>
                  </p>
                </td>
                <td></td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
                <td class="border-top border-bottom">
                  <p className="tender_drawing_react_body">
                    Attached <img src={download1Image} alt="" />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="comments_main">
            <h3>Comments</h3>
            <div class="comments_main_in">
              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input type="text" placeholder="Type comments..." />

                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="epy4fp"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="5izdv"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EvaluationCommercial;
